// Import 3rd-party dependencies
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Import project-specific dependencies
import { ApiService } from '@app/services/api.service';
import { environment } from '@app/environments/environment';

export interface IContentAdminLink {
  type: string;
  title: string;
  link: string;
  iconURL: string;
  index?: number;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalFunctionsService extends ApiService {
  private ADMIN_API_URL = environment.DEPS.ADMIN_API.URL;
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  globalFunctionsAdminList$ = this.get<IContentAdminLink[]>(`${this.ADMIN_API_URL}/cms/globalfunctions`);

  saveGlobalFunctions(globalFunc: IContentAdminLink): Observable<void> {
    const AddAdminLink = [
      {
        type: globalFunc.type,
        title: globalFunc.title,
        link: globalFunc.link,
        iconURL: globalFunc.iconURL,
        index: globalFunc.index
      }
    ];
    return this.put(`${this.ADMIN_API_URL}/cms/globalfunctions`, AddAdminLink[0]);
  }

  deleteGlobalFunctions(title: string): Observable<void> {
    return this.delete(`${this.ADMIN_API_URL}/cms/globalfunctions/delete?title=${title}`);
  }
}
